import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from "axios";
import { handleAxiosError } from '../../axios/handleAxiosError';
import { handleError } from '../../utils/handleError';
import { ChangePasswordRequestModel, PasswordState, ResetPasswordRequestModel, } from './_authTypes';
import { buildApiUrl } from '../../axios/urlCreator';

const initialState: PasswordState = {
    changedPasswordSuccessfully: false,
    resetPasswordSuccessfully: false,
    loading: false,
    error: null
};

export const changePassword = createAsyncThunk<boolean, ChangePasswordRequestModel>(
    'passwordSettings/changePassword',
    async (changePasswordRequestModel, { rejectWithValue }) => {
        try {
            const response = await axios.post(buildApiUrl("client/changePassword"), changePasswordRequestModel);
            return response.status == 204;
        }
        catch (error) {
            if (axios.isAxiosError(error)) {
                return rejectWithValue(handleAxiosError(error));
            }
            return rejectWithValue(handleError(error));
        }
    }
);

export const resetPassword = createAsyncThunk<boolean, ResetPasswordRequestModel>(
    'auth/resetPassword',
    async (resetPasswordRequestModel, { rejectWithValue }) => {
        try {
            const response = await axios.post(buildApiUrl("client/resetPassword"), resetPasswordRequestModel);
            return response.status == 204;
        }
        catch (error) {
            if (axios.isAxiosError(error)) {
                return rejectWithValue(handleAxiosError(error));
            }
            return rejectWithValue(handleError(error));
        }
    }
);

const passwordSlice = createSlice({
    name: 'passwordSettings',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // change password
            .addCase(changePassword.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(changePassword.fulfilled, (state, action) => {
                state.loading = false;
                state.changedPasswordSuccessfully = action.payload;
            })
            .addCase(changePassword.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })
            // reset password
            .addCase(resetPassword.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(resetPassword.fulfilled, (state, action) => {
                state.loading = false;
                state.resetPasswordSuccessfully = action.payload;
            })
            .addCase(resetPassword.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            });
    }
});


export default passwordSlice.reducer;